import { z } from "zod";
import { ShortText, idString } from "./common.js";
export const IMPACT_EFFORT_EXCLUDED_IDS_MAX = 1000;
const ImpactEffortPoint = z
    .object({
    id: idString,
    label: ShortText,
    /** Numeric scale; reference uses 0-10 with quadrant cutoff at 5. */
    effort: z.number().finite().min(0).max(10),
    impact: z.number().finite().min(0).max(10),
})
    .strict();
/**
 * Impact / Effort Matrix — Verify, singleton. 2×2 plot. Quadrants are
 * computed at render time: `impact > 5 && effort ≤ 5` = quick win, etc.
 * Points are draggable to reposition.
 */
export const ImpactEffortParamsSchema = z
    .object({
    points: z.array(ImpactEffortPoint).max(500),
    /** Entity ids explicitly hidden from this chart without deleting them. */
    excludedIds: z
        .array(idString)
        .max(IMPACT_EFFORT_EXCLUDED_IDS_MAX)
        .optional(),
})
    .strict();
export const defaultImpactEffortParams = {
    points: [],
    excludedIds: [],
};
//# sourceMappingURL=impactEffort.js.map